import React, { useCallback } from "react";
import styles from "./HorizontalMenu.module.scss";
import cx from "classnames";

interface Props {
  items: { value: string; label: string | React.ReactNode }[];
  value: string;
  onChange: (value: string) => void;
}
export default function HorizontalMenu({ items, value, onChange }: Props) {
  const onMenuChange = useCallback(
    (value: string) => () => onChange(value),
    [onChange]
  );
  return (
    <div className={cx(styles.section)}>
      {items.map((item, index) => (
        <>
          {index !== 0 && <span className={cx(styles.pipeSymbol)}>{"|"}</span>}
          <div
            className={cx(
              styles.nameMenu,
              value === item.value ? styles.active : styles.inactive
            )}
            onClick={onMenuChange(item.value)}
          >
            {item.label}
          </div>
        </>
      ))}
    </div>
  );
}
